import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import text from 'styles/utility/text.module.scss'

type Props = {
  isToday: boolean
  orderAmount: number
}

const OrderAmount: FC<Props> = (props) => {
  const { isToday, orderAmount } = props

  return (
    <>
      {orderAmount === 0 && !isToday ? (
        <p className={styles.calendar__amount}>
          表示できる注文が存在しません。
          <br />
          別の日を選択してください
        </p>
      ) : (
        <p className={styles.calendar__amount}>
          <span className={text.color_orange_main}>{orderAmount}件</span>
          <span>の注文があります</span>
        </p>
      )}
    </>
  )
}

export default OrderAmount
